<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [appendTo]="'body'"
  [baseZIndex]="200000"
  [blockScroll]="true"
  [style]="{ width: 'min(900px, 94vw)' }"
  styleClass="report-viewer-dialog"
>
  <ng-template pTemplate="header">
    <div class="rv-header">
      <div class="rv-header__info">
        <span class="rv-header__icon"><i class="pi" [ngClass]="fileIcon"></i></span>
        <div class="rv-header__text">
          <span class="rv-header__title">{{ title || 'Document' }}</span>
          <span class="rv-header__sub" *ngIf="fileTypeLabel">{{ fileTypeLabel }}</span>
        </div>
      </div>
      <div class="rv-header__actions">
        <button
          *ngIf="!loading && !errorMessage && (rawUrl || imageUrl)"
          type="button"
          class="rv-action rv-action--primary"
          (click)="openInNewTab()"
          title="Open in new tab"
        >
          <i class="pi pi-external-link"></i>
          <span>Open in new tab</span>
        </button>
        <button
          *ngIf="!loading && !errorMessage && (rawUrl || imageUrl)"
          type="button"
          class="rv-action"
          (click)="downloadFile()"
          title="Download"
        >
          <i class="pi pi-download"></i>
        </button>
      </div>
    </div>
  </ng-template>

  <div class="rv-body">
    <div *ngIf="loading" class="rv-state">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading document…</span>
    </div>

    <div *ngIf="!loading && errorMessage" class="rv-state rv-state--error">
      <i class="pi pi-exclamation-circle"></i>
      <span>{{ errorMessage }}</span>
      <button type="button" class="rv-action rv-action--primary" (click)="onRetry()">Retry</button>
    </div>

    <img
      *ngIf="!loading && !errorMessage && isImage && imageUrl"
      class="rv-image"
      [src]="imageUrl"
      [attr.data-key]="previewKey"
      [alt]="title"
    />

    <iframe
      *ngIf="!loading && !errorMessage && !isImage && documentUrl"
      class="rv-frame"
      [src]="documentUrl"
      [attr.data-key]="previewKey"
      [title]="title"
    ></iframe>
  </div>
</p-dialog>
